// Memorial entry for Ronen Engel
import ronenEngelPortrait from '../../../images/ronen-engel.jpg';

export const ronenEngelMemorial = {
  id: 36,
  name: 'Ronen Engel',
  images: {
    portrait: ronenEngelPortrait
  },
  info: `
"Ronen wasn't murdered. He fought until his last drop of blood, until the last bullet in his gun." - His brother Dani

# Ronen Engel

![Ronen Engel](${ronenEngelPortrait})
*Ronen Tommy Engel, 54, hero medic who died protecting his family*

## Always Look on the Bright Side

Ronen Engel had "ALWAYS" tattooed on his arm - a reference to Monty Python's "Always Look on the Bright Side of Life." It was his life motto. His catchphrase: "I'm crazy, but I'm optimistic."

He was a photojournalist for Haaretz and Israel Hayom, documenting kibbutz life with his camera. He restored vintage furniture. And two years before his death, he became an MDA (Magen David Adom) volunteer - an emergency medical responder affiliated with the Ofakim station. He was almost certified as an ambulance driver.

"He was always smiling, that was his hallmark," his MDA supervisor remembered. "Even at the worst accidents, he managed to make his patients smile."

He moved to Kibbutz Nir Oz in 2010 with his wife Karina and children Tom, Mika, and Yuval.

## October 7, 2023

When the attack began, Ronen grabbed his MDA medical bag and his weapon and ran out to help the wounded.

Hamas terrorists invaded his home. His brother said: "Ronen wasn't murdered. He fought until his last drop of blood, until the last bullet in his gun."

He was killed in his family's backyard defending them. His body was taken to Gaza. His MDA bag, bearing his name, was found abandoned in the kibbutz.

His wife Karina and daughters Mika and Yuval were kidnapped separately but later reunited in Gaza. They endured 52 days in captivity before being released in November 2023. Son Tom, serving in the IDF, was away.

## 744 Days

On December 1, 2023 - four days after his family's release - the IDF confirmed Ronen had been killed on October 7.

His body returned October 18, 2025 - 744 days later. He was buried at Nir Oz.

His wife Karina: "You were the heart of our home. The life beside you was an adventure - full of love, laughter, chaos, and music. Now the house is quiet."

His daughter Mika, 18: "It was you and me against the world - and now it's just me against the world. I died on October 7 too, but only you stopped breathing."

His youngest, Yuval: "You were always laughing, always optimistic. You're my hero."

## His Legacy

After his death, the family got matching tattoos bearing his motto: "F***ed up, yet optimistic."

MDA Director-General Eli Bin: "Ronen was a beloved, skilled, and dedicated volunteer who saved lives. He fell in the course of that mission. His legacy of saving lives will never be forgotten."

*Always look on the bright side of life. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/ronen-engel-54-photographer-dad-who-was-always-smiling/)
`
};
